import { RefObject, useCallback, useEffect, useLayoutEffect, useRef } from 'react';

const useOnClickOutside = <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  onClick?: (event: MouseEvent) => void
): void => {
  const handler = useCallback(
    (event: MouseEvent) => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }
      onClick?.(event);
    },
    [onClick, ref]
  );

  const savedHandler = useRef(handler);

  useLayoutEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(() => {
    const listener: typeof onClick = (event) => savedHandler.current(event);

    window.addEventListener('click', listener);
    return () => {
      window.removeEventListener('click', listener);
    };
  });
};

export default useOnClickOutside;
